import { useQuery } from '@apollo/client';
import { GET_FABRIC_REVIEWS } from '../../mocks/queries';

const useFabricReviews = fabricId => {
  const { loading, error, data } = useQuery(GET_FABRIC_REVIEWS, {
    variables: { fabricValueId: fabricId?.toString() },
    skip: !fabricId,
  });

  return {
    loading,
    error,
    data: {
      rating: data?.getFabricReviews?.rating,
      reviews: data?.getFabricReviews?.reviews,
    },
  };
};

export default useFabricReviews;
